import { Box, MenuItem, Typography } from '@mui/material';
import { ReactElement } from 'react';

type TNavBarAccountMenuItemProps = {
  onClick?: any;
  startIcon?: ReactElement;
  title: string;
};

export const NavBarAccountMenuItem = ({
  onClick,
  startIcon,
  title,
}: TNavBarAccountMenuItemProps) => {
  const handleClick = (e) => {
    onClick(e);
  };

  return (
    <MenuItem onClick={handleClick}>
      <Box
        sx={{
          '& svg': { mr: 2, width: 20, height: 20 },
          color: '#657482',
        }}
      >
        {startIcon}
      </Box>
      <Typography variant="subtitle2" noWrap color="#657482">
        {title}
      </Typography>
    </MenuItem>
  );
};
